import { Draft } from "immer";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { DanaWarehousesState } from "./WarehousesState";

const initialState: DanaWarehousesState = {
    isLoading: false,
    loadSuccess: false,
    warehouses: null,
    errorMessage: '',
};

const reducer =  createTypedReducerWithImmer(initialState, {
    "DanaWarehouses/Start": (draft: Draft<DanaWarehousesState>, action: { isLoading: boolean, loadSuccess: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading, loadSuccess: action.loadSuccess };
        return draft;
    },
    "DanaWarehouses/LoadResponse": (draft: Draft<DanaWarehousesState>, action: { warehouses: WarehouseModel[], errorMessage: string }) => {
        draft = {
            ...draft,
            warehouses: action.warehouses,
            errorMessage: action.errorMessage
        };
        return draft;
    },
    "DanaWarehouses/End": (draft: Draft<DanaWarehousesState>, action: { isLoading: boolean, loadSuccess: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading, loadSuccess: action.loadSuccess, };
        return draft;
    }
});

(reducers as any).danaWarehouseState = reducer;

type DanaWarehousesReducers = {
    danaWarehouseState: typeof reducer;
};

export type DanaWarehousesActions = Parameters<DanaWarehousesReducers[keyof DanaWarehousesReducers]>[1] | AnyAction;